/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Select from "../../../components/input/select";
import TrackerDetail from "../../../components/tracker-detail/tracker-detail";
import { AIR_TABLE_KEY } from "../../../env";
import { IOptions } from "../../../models/options";
import { isEmpty } from "../../../utils/validations";

const localizer = momentLocalizer(moment);

const TrackerAdminAluxionersCalendar: React.FC = () => {
  const [data, setData] = useState<any>([]);
  const [projectColors, setProjectColors] = useState<any>({});
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [selectedEventClickPostion, setSelectedEventClickPostion] = useState<
    any
  >({
    x: 0,
    y: 0,
  });
  const [employees, setEmployees] = useState<any>([]);
  const [currentDate, setCurrentDate] = useState(moment().toISOString());
  const [page, setPage] = useState<number>(0);
  const [offsets, setOffsets] = useState<any>([]);
  const [filters, setFilters] = useState<any>({
    "Fecha Hour Tracker": moment().toISOString(),
  });

  const colors = [
    "#3c96b4",
    "#3aa537",
    "#8c5ac8",
    "#ffd048",
    "#e5546c",
    "#faa082",
    "#000000",
    "#e677d7",
    "#fdeab6",
    "#cccccc",
    "#d74d2f",
    "#b8762d",
    "#ba2c45",
    "#2e7ff6",
    "#44a09c",
    "#4bbff8",
  ];

  useEffect(() => {
    getEmployees();
    return () => {
      setOffsets([]);
      setData([]);
      setPage(0);
    };
  }, []);

  useEffect(() => {
    setPage(0);
    setOffsets([]);
    if (filters.Aluxioner) {
      getTrackers({ filters });
    }
  }, [currentDate, filters]);

  const getEmployees = async () => {
    const res: any = await axios.get(
      "https://api.airtable.com/v0/appNIeE8Lj55AIrXc/Aluxioners",
      {
        params: {
          api_key: AIR_TABLE_KEY,
          pageSize: 100,
        },
      }
    );

    const res2: any = await axios.get(
      "https://api.airtable.com/v0/appNIeE8Lj55AIrXc/Talent",
      {
        params: {
          api_key: AIR_TABLE_KEY,
          pageSize: 100,
        },
      }
    );

    const employeesData = res.data.records
      .map((item: any) => ({
        value: item.fields.Name,
        label: item.fields.Name,
      }))
      .concat(
        res2.data.records.map((item: any) => ({
          value: item.fields.Name,
          label: item.fields.Name,
        }))
      );

    setEmployees(employeesData);
  };

  const getFilter = (filtersObj?: any) => {
    const initDate = moment(currentDate)
      .startOf("month")
      .add(-1, "days")
      .format("DD/MM/YYYY");
    const finalDate = moment(currentDate)
      .endOf("month")
      .add(1, "days")
      .format("DD/MM/YYYY");
    const filtersAux = [
      `IS_AFTER({Fecha Hour Tracker}, DATETIME_PARSE('${initDate}',  'DD/MM/YYYY')),
      IS_BEFORE({Fecha Hour Tracker}, DATETIME_PARSE('${finalDate}', 'DD/MM/YYYY'))`,
    ];
    if (filtersObj) {
      if (filtersObj.Aluxioner && !isEmpty(filtersObj.Aluxioner.value)) {
        filtersAux.push(`FIND('${filtersObj.Aluxioner.value}', {Aluxioner})`);
      }
    }
    return filtersAux.length > 0 ? `AND(${filtersAux.join(",")})` : "";
  };

  const getTrackers = async (options?: IOptions) => {
    const newPage =
      options?.next === undefined ? 0 : options?.next ? page + 1 : page - 1;

    const res: any = await axios.get(
      "https://api.airtable.com/v0/appHXEAplyyE7zksw/Table%201",
      {
        params: {
          api_key: AIR_TABLE_KEY,
          pageSize: 100,
          offset: offsets[newPage - 1] || "",
          filterByFormula: getFilter(options?.filters),
        },
      }
    );

    let auxProjectColors = { ...projectColors };
    res.data.records.forEach((tracker: any) => {
      if (!Object.keys(auxProjectColors).includes(tracker.fields.Proyecto)) {
        const color = colors.find(
          (colorAux: string) =>
            !Object.values(auxProjectColors).includes(colorAux)
        );
        auxProjectColors = {
          ...auxProjectColors,
          [tracker.fields.Proyecto]: color,
        };
      }
    });

    setProjectColors(auxProjectColors);

    let trackersMapped = [];
    trackersMapped = res.data.records.map((item: any, index: number) => ({
      title: `${item.fields.Proyecto} - ${item.fields.Horas} horas`,
      start: moment(item.fields["Fecha Hour Tracker"], "YYYY-MM-DD").add(
        "hour",
        12
      ),
      end: moment(item.fields["Fecha Hour Tracker"], "YYYY-MM-DD").add(
        "hour",
        12
      ),
      raw: item,
      resources: [index],
    }));

    setData(trackersMapped);
  };

  const handleFilters = (name: string, value: any) => {
    filters[name] = value;
    setFilters({ ...filters });
  };

  return (
    <>
      <div className="tracker-filter-container">
        <div className="tracker-filter-item">
          <Select
            label={"Nombre"}
            value={filters.Aluxioner}
            onChange={(option: any) => handleFilters("Aluxioner", option)}
            options={employees}
            placeholder="Seleccione Aluxioner"
            customEmpty="Escribe un nombre"
          />
        </div>
        {!filters.Aluxioner && (
          <div className="tracker-filter-alert">
            Selecciona un Aluxioner para ver su calendario
          </div>
        )}
      </div>
      <Calendar
        views={["month"]}
        localizer={localizer}
        events={data}
        popup={true}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 700 }}
        titleAccessor={(event) => event.title}
        eventPropGetter={(event) => ({
          className: `custom-event
       ${event.raw.fields["¿Aprobado Manager?"] ? "manager-check " : ""}
       ${event.raw.fields["¿Aprobado RRHH?"] ? "rrhh-check " : ""}`,
          style: {
            background: projectColors[event.raw.fields.Proyecto],
          },
        })}
        onSelectEvent={(event: any, ev: any) => {
          setSelectedEvent(event.raw.fields);
          setSelectedEventClickPostion({
            x: ev.clientX,
            y: ev.clientY,
          });
        }}
        onNavigate={(date) => {
          if (!moment(date).isSame(moment(currentDate), "month")) {
            setCurrentDate(date.toISOString());
          }
        }}
      />
      {selectedEvent && (
        <TrackerDetail
          name={selectedEvent.Aluxioner}
          date={selectedEvent["Fecha Hour Tracker"]}
          project={selectedEvent.Proyecto}
          task={selectedEvent["Tareas realizadas"]}
          hours={selectedEvent.Horas}
          blockers={selectedEvent.Blockers}
          onClose={() => setSelectedEvent(null)}
          initialPositions={selectedEventClickPostion}
        />
      )}
    </>
  );
};

export default TrackerAdminAluxionersCalendar;
